import CardSubInfo from "../../../components/CardSubInfo";
const PackageInfo = ({ setCreateEventModal, packageInfo }) => {
  return (
    <>
      <div
        className={`fixed p-15 w-full max-w-[900px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]`}
      >
        <div className="py-10 md:px-10 px-[7px] bg-card-color rounded-lg shadow-shadow-lg">
          <div className="my-10 lg:px-20 md:px-10 px-[7px] md:max-h-[80svh] max-h-[60svh] overflow-auto custom-scrollbar">
            <div className="text-[24px]/[30px] font-medium mb-2">
              ინფორმაცია გზავნილზე
            </div>
            <div className="card bg-card-color rounded-xl p-4 relative border border-dashed border-border-color">
              <h5 className="my-2 text-[16px]/[20px] font-medium">გზავნილი</h5>
              <CardSubInfo
                title={"გზავნილის ნომერი:"}
                data={packageInfo?.trackingNumber}
              />
              <CardSubInfo
                title={"რაოდენობა"}
                data={packageInfo?.orderInfo.pieceQuantity}
              />
              <CardSubInfo
                title={"წონა"}
                data={packageInfo?.orderInfo.weight}
              />
              <CardSubInfo
                title={"თანხა"}
                data={packageInfo?.orderInfo.amount}
              />
              <CardSubInfo
                title={"სტატუსი"}
                data={packageInfo?.orderInfo.orderStatus}
              />
            </div>
            <div className="card bg-card-color rounded-xl p-4 relative border border-dashed border-border-color mt-10">
              <h5 className="my-2 text-[16px]/[20px] font-medium">
                ინფორმაცია გამგზავნზე
              </h5>
              <CardSubInfo
                title={"დასახელება:"}
                data={packageInfo?.sender?.name}
              />
              <CardSubInfo
                title={"მისამართი:"}
                data={packageInfo?.sender?.address}
              />
              <CardSubInfo
                title={"საქონტაქტო პირი:"}
                data={packageInfo?.sender?.contactName}
              />
              <CardSubInfo
                title={"ტელეფონი:"}
                data={packageInfo?.sender?.contactPhone}
              />
            </div>
            <div className="card bg-card-color rounded-xl p-4 relative border border-dashed border-border-color mt-10">
              <h5 className="my-2 text-[16px]/[20px] font-medium">
                ინფორმაცია მიმღებზე
              </h5>
              <CardSubInfo
                title={"დასახელება:"}
                data={packageInfo?.receiver?.name}
              />
              <CardSubInfo
                title={"მისამართი:"}
                data={packageInfo?.receiver?.address}
              />
              <CardSubInfo
                title={"საქონტაქტო პირი:"}
                data={packageInfo?.receiver?.contactName}
              />
              <CardSubInfo
                title={"ტელეფონი:"}
                data={packageInfo?.receiver?.contactPhone}
              />
            </div>
            <div className="flex items-stretch gap-5 mt-10">
              <button
                onClick={setCreateEventModal}
                className="btn btn-secondary"
              >
                დახურვა
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        onClick={setCreateEventModal}
        className={`contents-[] fixed z-[5] w-full h-full left-0 top-0 bg-black-50 backdrop-blur-[2px]`}
      ></div>
    </>
  );
};

export default PackageInfo;
